import { useMutation, useQuery, useQueryClient } from 'react-query';

import { Rating } from '../../models/Rating';
import carrierService from '../../services/carrierService';
import ratingService from '../../services/ratingService';

export const useCarrierRating = (carrierId?: number) => {
  const { data, isLoading, status } = useQuery(
    ['carrierRating', carrierId],
    () => carrierService.getRating(carrierId!),
    {
      enabled: !!carrierId,
    }
  );

  return {
    isLoading,
    rating: data,
    status,
  };
};

export const useRatingUpdate = () => {
  const queryClient = useQueryClient();

  return useMutation<Rating, Error, Rating>(ratingService.update, {
    onSuccess: (data) => {
      queryClient.setQueryData<Rating | undefined>(
        ['carrierRating', data.carrierId],
        () => data
      );
    },
  });
};
